document.addEventListener('DOMContentLoaded', () => {

  const modal = document.getElementById('wholesale-overlay');

  if (!modal) return;

  const closeBtn = modal.querySelector('.qv-close');

  const slider = document.getElementById('wholesale-slider');
  const title = document.getElementById('wholesale-title');
  const price = document.getElementById('wholesale-price');

  document.addEventListener('click', async (e) => {

    const wholesaleSection = e.target.closest('.wholesale-products');

    if (!wholesaleSection) return;

    const trigger = e.target.closest('.wholesale-trigger');

    if (!trigger) return;

   e.preventDefault();
e.stopPropagation();

    const handle = trigger.dataset.productHandle;

    if (!handle) return;

    try {

      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      slider.innerHTML = '';

      product.images.forEach(img => {

        slider.innerHTML += `
          <div class="wholesale-slide-wrap">
            <img src="${img}" class="wholesale-slide">
          </div>
        `;

      });

      title.textContent = product.title;

      price.textContent = (product.price / 100).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP'
      });

      modal.classList.add('active');

    } catch (error) {

      console.error(error);

    }

  });

  closeBtn.addEventListener('click', () => {

    modal.classList.remove('active');

  });

  modal.addEventListener('click', (e) => {

    if (e.target === modal) {
      modal.classList.remove('active');
    }

  });

});